import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  contentTargetConnected(el) {
    this._contentEl = el
  }

  show() {
    const el = this._contentEl
    if (!el) return

    // Portal to document.body to escape CSS transform containing blocks
    this._originalParent = el.parentNode
    this._originalNextSibling = el.nextSibling
    document.body.appendChild(el)

    el.classList.remove("hidden")

    const trigger = this.element
    const rect = trigger.getBoundingClientRect()

    el.style.position = "fixed"
    el.style.left = `${rect.left + rect.width / 2}px`
    el.style.transform = "translateX(-50%)"
    el.style.bottom = ""
    el.style.top = ""

    // Position above the trigger
    const popoverRect = el.getBoundingClientRect()
    const top = rect.top - popoverRect.height - 4

    if (top < 4) {
      el.style.top = `${rect.bottom + 4}px`
    } else {
      el.style.top = `${top}px`
    }
  }

  hide() {
    const el = this._contentEl
    if (!el) return

    el.classList.add("hidden")

    if (this._originalParent) {
      if (this._originalNextSibling) {
        this._originalParent.insertBefore(el, this._originalNextSibling)
      } else {
        this._originalParent.appendChild(el)
      }
      this._originalParent = null
      this._originalNextSibling = null
    }
  }
}
